import { useDispatch, useSelector } from 'react-redux';
import { useForm, useFormState } from 'react-final-form';
import {
  setChosenLocationNames,
  setCurrentCity,
  setLocationIds
} from '../actions';
import {
  selectSearchFormCurrentCity,
  selectSearchLocationNames
} from '../store/selectors';
import { InitialFormValuesType } from '../components/NewSearch/NewSearchBar/types';

export function useUndoFilters() {
  const dispatch = useDispatch();
  const { values } = useFormState();
  const { change } = useForm();
  const currentCity = useSelector(selectSearchFormCurrentCity);
  const chosenLocationNames = useSelector(selectSearchLocationNames);

  return (initialValues?: InitialFormValuesType | null) => {
    const valuesToUndo = initialValues || values;

    Object.keys(valuesToUndo).forEach(key => {
      change(key, valuesToUndo[key]);
    });

    dispatch(setChosenLocationNames(chosenLocationNames));
    dispatch(setLocationIds(valuesToUndo.location_ids));
    dispatch(setCurrentCity(currentCity));
  };
}
